<template>
  <BaseAction>
    <SecondaryButton
      @click.native="openCancelBookingDialog"
      textColor="#d10a3a"
    >
      <v-icon>
        mdi-archive-outline
      </v-icon>
      Archive Org Unit
    </SecondaryButton>
    <ArchiveUnitDialog
      v-if="isOpen"
      :isOpen="isOpen"
      :unit="unit"
      @close="closeCancelBookingDialog"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import ArchiveUnitDialog from "@/views/settings/Organisation/Units/dialogs/ArchiveUnitDialog";

export default {
  props: {
    unit: {
      type: Object,
      require: true
    }
  },
  components: {
    BaseAction,
    SecondaryButton,
    ArchiveUnitDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openCancelBookingDialog() {
      this.isOpen = true;
    },
    closeCancelBookingDialog() {
      this.isOpen = false;
    }
  }
};
</script>
